import { render, staticRenderFns } from "./AccountFeedback.vue?vue&type=template&id=6abf19b8&"
import script from "./AccountFeedback.vue?vue&type=script&lang=js&"
export * from "./AccountFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AccountFeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports